import React from "react";
import { Attachments, KeyValue, Violations, Toast, DatePicker, EditableInput, EditableSelect, Remarks, Button } from "../..";
import StatusIndicator from "../Components/status";
import { apis, patch } from "../../../Utils/axios";
import moment from "moment";
import useFetch from "../../../Hooks/useFetch";
import NextAction from "./nextAction";
import { useClientSettings } from "Hooks/useClientSettings";
import { formatedPrice, StampToDate, StampTo24hr, minutesToHrMin } from "Utils/utils";
import BookingSelect from "../../../Pages/App/Employee/Expense/Receipts/AddReceipt/booking-select";
import { FiX, FiPlus } from "react-icons/fi";
import { FaPlane } from "react-icons/fa";

function EditableReceipt({ receipt, onReload = () => {} }) {
	const { currency } = useClientSettings();
	const { response } = useFetch(apis.getExpenseCategories, null, { categories: [] });
	const { id, date, amount, category, status, description, violations, remarks, flight } = receipt;

	const onUpdate = (obj) => {
		patch(`/receipts/${id}`, obj, (r, e) => {
			if (r) {
				Toast.success(`Receipt Updated`);
				onReload();
			} else if (e) {
				Toast.handleError(e);
			}
		});
	};

	const removeLinkedFlight = () => {
		onUpdate({ flightId: null });
	};

	const handleBookingSelect = (booking) => {
		if (booking?.id) {
			onUpdate({ flightId: booking.id });
		}
	};

	return (
		<>
			<div className="p-4 rounded-t-lg shadow-sm bg-canvas">
				<h1>Expense</h1>
				<div className="mt-6">
					<h4>Receipt Details</h4>
					<div className="flex flex-col gap-y-2 mt-4">
						<Violations className="mb-2" violations={violations} />
						<KeyValue label="Receipt ID">{id}</KeyValue>
						<KeyValue label="Date">
							<DatePicker btnClass="!py-1 !text-xs max-w-min" date={date} setDate={(date) => onUpdate({ date: moment(date).format("DD-MM-YYYY") })} backDateSelection maxDate={moment().valueOf()} />
						</KeyValue>
						<KeyValue label="Amount">
							<EditableInput required onUpdate={(amount) => onUpdate({ amount })} value={amount} label="Amount" /> {currency} {formatedPrice(amount)}
						</KeyValue>
						<KeyValue label="Category">
							<EditableSelect options={response.categories.map((c) => ({ value: c.id, label: c.name }))} onChange={(category) => onUpdate({ categoryId: category.value })} selected={{ label: category?.name || "None", value: category?.id }} />
						</KeyValue>
						<KeyValue label="Purpose">
							<EditableInput required onUpdate={(description) => onUpdate({ description })} value={description} label="Description" />
							{description}
						</KeyValue>
						<KeyValue label="Status">
							<StatusIndicator status={status.toLowerCase()} />
						</KeyValue>
					</div>
					{flight ? (
						<div>
							<div className="flex justify-between items-center mt-4">
								<h6 className="flex gap-x-2 items-center text-sm">
									<FaPlane className="w-3" />
									Expense tagged to Flight
								</h6>
								<Button onClick={removeLinkedFlight} className="btn-xs" variant="danger">
									<FiX className="mr-1" size={12} />
									Remove
								</Button>
							</div>
							<div className="overflow-hidden mt-4 min-w-min rounded-xl border shadow-sm bg-canvas">
								<div className="p-4">
									<div className="flex justify-between items-start">
										<div className="align-center">
											<img
												src={`https://cdn.travelwings.com/globalassets/images/${flight.airlineCode?.toUpperCase()}.jpg`}
												alt={flight.airlineCode}
												className="mr-2 w-6 h-6 rounded-full"
												onError={(e) => {
													e.target.src =
														"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23ccc' d='M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'/%3E%3C/svg%3E";
												}}
											/>
											<div className="text-xs whitespace-nowrap text-secondary">
												{flight.airlineCode}-{flight.flightNumber}
											</div>
										</div>
										<div className="text-xs font-bold">{StampToDate(flight.departureTime)}</div>
									</div>
									<div className="flex gap-x-4 mt-3">
										<div>
											<div className="font-bold whitespace-nowrap">{flight.departureCode}</div>
											<div className="text-xs text-secondary">{StampTo24hr(flight.departureTime)}</div>
										</div>
										<div className="flex-grow w-24 flex-center">
											<div className="w-full">
												<div className="align-center">
													<div className="w-2 h-2 rounded-full border border-dark" />
													<div className="flex-grow border-t border-dotted border-dark" />
													<FaPlane />
													<div className="flex-grow border-t border-dotted border-dark" />
													<div className="w-2 h-2 rounded-full border border-dark" />
												</div>
												<div className="mt-2 text-xs text-center whitespace-nowrap">{minutesToHrMin(flight.duration)}</div>
											</div>
										</div>
										<div>
											<div className="font-bold whitespace-nowrap">{flight.arrivalCode}</div>
											<div className="text-xs text-secondary">{StampTo24hr(flight.arrivalTime)}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className="mt-4">
							<h6 className="flex gap-x-2 items-center mb-2 text-sm">Tag a Flight Booking</h6>
							<BookingSelect selected={{}} onSelect={handleBookingSelect} label="" />
						</div>
					)}
					{receipt.attachments?.length > 0 && (
						<>
							<h4 className="mt-4">Attachments</h4>
							<Attachments className="mt-4" files={receipt.attachments} />
						</>
					)}
					<Remarks remarks={remarks} className="mt-4" />
				</div>
			</div>
			<div className="rotate-180 zigzag" />
			<NextAction status={status} />
		</>
	);
}

export default EditableReceipt;
